import { roundWithDecimals } from '../../../../utils/format';

export const calculateAdvancePercentage = (value, total) => {
  const numericTotal = Number(total);

  if (!Number.isFinite(numericTotal) || numericTotal === 0) {
    return roundWithDecimals(0, 2);
  }

  const numericValue = Number(value);
  const percent = (numericValue * 100) / numericTotal;

  if (!Number.isFinite(percent)) {
    return roundWithDecimals(0, 2);
  }

  return roundWithDecimals(percent, 2);
};
